module.exports = __webpack_public_path__ + "img/31.df18f13b.png";